import { Env } from '@/shared/config/environment';
import { HttpClient } from '@/shared/lib/http-client';

export const confirmAccidentContract = async (data) => {
  const response = await HttpClient.post(`${Env.server.mode}/insurance/accident/contract/confirm`, data);

  return response.data;
};
